import { defineMessages } from 'react-intl';

export const resourceCostsMessageDefinitions = defineMessages({
  costPerUnitTitle: {
    id: 'estimationDetail.resourceCosts.costPerUnitTitle',
    defaultMessage: 'Cost per Resource Unit',
  },
  currency: {
    id: 'estimationDetail.resourceCosts.currency',
    defaultMessage: 'Currency',
  },
  costBreakDownTitle: {
    id: 'estimationDetail.resourceCosts.costBreakDownTitle',
    defaultMessage: 'Resource Cost Breakdown',
  },
  estimationUnit: {
    id: 'estimationDetail.resourceCosts.estimationUnit',
    defaultMessage: 'Estimation Unit',
  },
  costUnit: {
    id: 'estimationDetail.resourceCosts.costUnit',
    defaultMessage: 'Cost Unit',
  },
  subTotal: {
    id: 'estimationDetail.resourceCosts.subTotal',
    defaultMessage: 'Subtotal',
  },
  costsRecalculating: {
    id: 'estimationDetail.resourceCosts.costsRecalculating',
    defaultMessage: 'Recalculating',
  },
});
